/* Eterna — comportements du thème. Aucune dépendance. */
(function(){
'use strict';

/* ---------- volets (navigation, filtres, tri) ---------- */
var scrim=document.querySelector('.scrim');
var navDrawer=document.getElementById('nav-drawer');
var panel=document.getElementById('panel');
var dernierFocus=null;

function fermerTout(){
  [navDrawer,panel].forEach(function(d){ if(d){d.classList.remove('is-open');d.setAttribute('aria-hidden','true');} });
  if(scrim) scrim.classList.remove('is-open');
  document.body.style.overflow='';
  document.querySelectorAll('[data-drawer],[data-panel]').forEach(function(b){b.setAttribute('aria-expanded','false');});
  if(dernierFocus){dernierFocus.focus();dernierFocus=null;}
}
function ouvrir(el){
  if(!el) return;
  [navDrawer,panel].forEach(function(d){ if(d&&d!==el){d.classList.remove('is-open');d.setAttribute('aria-hidden','true');} });
  el.classList.add('is-open'); el.setAttribute('aria-hidden','false');
  if(scrim) scrim.classList.add('is-open');
  document.body.style.overflow='hidden';
  var f=el.querySelector('button,a,select,input'); if(f) f.focus();
}

/* volet navigation : bascule menu / marques / catégories sans recharger */
function ouvrirNav(type){
  if(!navDrawer) return;
  var titre=document.getElementById('drawer-title');
  if(titre) titre.textContent = type==='marque' ? 'Marques' : type==='categorie' ? 'Catégories' : 'Menu';
  navDrawer.querySelectorAll('[data-taxo]').forEach(function(ul){ ul.hidden = ul.dataset.taxo!==type; });
  navDrawer.querySelectorAll('[data-note]').forEach(function(p){ p.hidden = p.dataset.note!==type; });
  ouvrir(navDrawer);
}
/* volet filtres : bascule filtres / tri */
function ouvrirPanel(pane){
  if(!panel) return;
  var titre=document.getElementById('panel-title');
  if(titre) titre.textContent = pane==='tri' ? 'Trier' : 'Filtrer';
  panel.querySelectorAll('[data-pane]').forEach(function(d){ d.hidden = d.dataset.pane!==pane; });
  panel.querySelectorAll('[data-pane-only]').forEach(function(d){ d.hidden = d.dataset.paneOnly!==pane; });
  ouvrir(panel);
}

document.addEventListener('click',function(e){
  var d=e.target.closest('[data-drawer]');
  if(d){ e.preventDefault(); dernierFocus=d; ouvrirNav(d.getAttribute('data-drawer')); d.setAttribute('aria-expanded','true'); return; }
  var mg=e.target.closest('[data-menu-goto]');
  if(mg){ e.preventDefault(); ouvrirNav(mg.getAttribute('data-menu-goto')); return; }
  var p=e.target.closest('[data-panel]');
  if(p){ e.preventDefault(); dernierFocus=p; ouvrirPanel(p.getAttribute('data-panel')); p.setAttribute('aria-expanded','true'); return; }
  if(e.target.closest('[data-close]')) fermerTout();
});
document.addEventListener('keydown',function(e){ if(e.key==='Escape') fermerTout(); });

/* ---------- rails : défilement en boucle ---------- */
document.querySelectorAll('[data-loop="true"]').forEach(function(rail){
  var enfants=Array.prototype.slice.call(rail.children);
  if(enfants.length<3) return;
  enfants.forEach(function(n){ rail.appendChild(n.cloneNode(true)); });
  enfants.forEach(function(n){ rail.appendChild(n.cloneNode(true)); });
  var seg=function(){ return rail.scrollWidth/3; };
  requestAnimationFrame(function(){ rail.scrollLeft=seg(); });
  rail.addEventListener('scroll',function(){
    var s=seg();
    if(rail.scrollLeft>=s*2) rail.scrollLeft-=s;
    else if(rail.scrollLeft<4) rail.scrollLeft+=s;
  });
});

/* ---------- révélation au défilement ---------- */
if('IntersectionObserver' in window){
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('is-in'); io.unobserve(x.target); } });
  },{rootMargin:'-8% 0px'});
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
}

/* ---------- validation des formulaires ---------- */
/* [indicatif, libellé, longueur min, longueur max] — numéro national, 0 initial exclu */
var PAYS=[['+33','FR',9,9],['+32','BE',8,9],['+41','CH',9,9],['+352','LU',6,9],['+377','MC',8,8],
          ['+34','ES',9,9],['+39','IT',9,10],['+49','DE',10,11],['+44','GB',10,10],['+31','NL',9,9],
          ['+351','PT',9,9],['+1','US/CA',10,10],['+81','JP',9,10]];
var RE_MAIL=/^[^\s@]+@[^\s@.]+(\.[^\s@.]{2,})+$/;

function marquer(el,ko){ if(el) el.classList.toggle('is-error',!!ko); }
function dire(z,msg,ok){ if(!z) return; z.textContent=msg||''; z.classList.toggle('ok',!!ok); }

function validerMail(input,zone){
  var v=input.value.trim();
  if(!v){ marquer(input,false); dire(zone,''); return false; }
  var ok=RE_MAIL.test(v);
  marquer(input,!ok);
  dire(zone, ok?'Adresse valide.':'Il manque quelque chose : une adresse s\'écrit nom@domaine.fr', ok);
  return ok;
}
function validerTel(sel,input,zone,hidden){
  var p=null;
  for(var i=0;i<PAYS.length;i++){ if(PAYS[i][0]===sel.value){ p=PAYS[i]; break; } }
  if(!p) p=PAYS[0];
  var n=input.value.replace(/\D/g,'').replace(/^0+/,'');
  input.value=n.replace(/(\d{2})(?=\d)/g,'$1 ').trim();
  if(hidden) hidden.value = n ? p[0]+' '+input.value : '';
  if(!n){ marquer(input,false); marquer(sel,false); dire(zone,''); return false; }
  var attendu = p[2]===p[3] ? p[2]+' chiffres' : p[2]+' à '+p[3]+' chiffres';
  var ok = n.length>=p[2] && n.length<=p[3];
  marquer(input,!ok); marquer(sel,!ok);
  dire(zone, ok ? 'Numéro complet — '+p[0]+' '+input.value
                : 'Un numéro '+p[1]+' compte '+attendu+' après l\'indicatif. Vous en avez saisi '+n.length+'.', ok);
  return ok;
}

/* champ e-mail : toute zone .err placée juste après */
document.querySelectorAll('input[type="email"]').forEach(function(input){
  var zone=input.parentNode.querySelector('.err');
  input.addEventListener('input',function(){ validerMail(input,zone); });
});

/* champ téléphone avec indicatif */
document.querySelectorAll('[data-phone]').forEach(function(bloc){
  var sel=bloc.querySelector('select'), input=bloc.querySelector('input[type="tel"]');
  var zone=bloc.parentNode.querySelector('.err');
  var hidden=bloc.parentNode.querySelector('input[type="hidden"]');
  sel.innerHTML=PAYS.map(function(p){ return '<option value="'+p[0]+'">'+p[1]+' '+p[0]+'</option>'; }).join('');
  input.addEventListener('input',function(){ validerTel(sel,input,zone,hidden); });
  sel.addEventListener('change',function(){ validerTel(sel,input,zone,hidden); });
});

/* budget : chiffres uniquement, séparateur de milliers automatique */
document.querySelectorAll('[data-numerique]').forEach(function(input){
  input.addEventListener('input',function(){
    var n=input.value.replace(/\D/g,'');
    input.value = n ? Number(n).toLocaleString('fr-FR') : '';
  });
});

/* marque « Autre maison » : révèle un champ libre */
var selMarque=document.getElementById('s-marque');
if(selMarque){
  selMarque.addEventListener('change',function(){
    var autre=selMarque.value==='Autre maison';
    var wrap=document.getElementById('wrap-autre');
    if(wrap){ wrap.classList.toggle('hidden',!autre); if(autre) wrap.querySelector('input').focus(); }
  });
}

/* nom du fichier photo */
var photo=document.getElementById('s-photo');
if(photo){
  photo.addEventListener('change',function(){
    var f=photo.files[0]; if(!f) return;
    var d=document.querySelector('.drop');
    d.querySelector('.t').textContent=f.name;
    d.querySelector('.s').textContent='Photo ajoutée — cliquez pour remplacer';
  });
}

/* ---------- certificat d'authenticité : ajout groupé sac + certificat ---------- */
(function(){
  var form = document.getElementById('form-achat');
  if(!form) return;
  var toggle = form.querySelector('#certif-toggle');
  if(!toggle) return;
  form.addEventListener('submit', function(e){
    if(!toggle.checked) return;
    e.preventDefault();
    var boutons = form.querySelectorAll('button[type="submit"]');
    var intention = e.submitter ? e.submitter.name : 'add';
    var bagId = form.querySelector('input[name="id"]').value;
    var certifId = toggle.getAttribute('data-certificat-variant');
    var certifTitre = toggle.getAttribute('data-certificat-titre');
    var cartUrl = form.getAttribute('data-cart-url') || '/cart';
    boutons.forEach(function(b){ b.disabled = true; });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items: [
        { id: bagId, quantity: 1 },
        { id: certifId, quantity: 1, properties: { 'Pièce concernée': certifTitre, 'Variante': bagId } }
      ]})
    }).then(function(r){ if(!r.ok) throw new Error('cart'); return r.json(); })
      .then(function(){ window.location.href = intention === 'checkout' ? '/checkout' : cartUrl; })
      .catch(function(){ boutons.forEach(function(b){ b.disabled = false; }); toggle.checked = false; form.submit(); });
  });
})();

/* ---------- panier : retirer un sac retire son certificat ---------- */
(function(){
  document.addEventListener('click', function(e){
    var lien = e.target.closest('[data-remove-line]');
    if(!lien) return;
    var ligne = lien.closest('.cartline');
    if(!ligne) return;
    e.preventDefault();
    var updates = {};
    updates[ligne.getAttribute('data-line-key')] = 0;
    var certifKey = ligne.getAttribute('data-certif-key');
    if(certifKey) updates[certifKey] = 0;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ updates: updates })
    }).then(function(){ window.location.reload(); })
      .catch(function(){ window.location.href = lien.href; });
  });
})();

/* ---------- volet filtres : mémorise le panneau ouvert après application ----------
   Le filtrage et le tri sont faits par Shopify, côté serveur. Ce bloc ne sert
   qu'au confort : rouvrir le volet si l'URL porte déjà des filtres n'a pas de sens,
   on se contente de refléter l'état dans le bouton. */
(function(){
  var form = document.getElementById('form-filtres');
  if(!form) return;
  /* soumission automatique si l'utilisateur navigue au clavier et valide */
  form.addEventListener('keydown', function(e){
    if(e.key === 'Enter' && e.target.type === 'checkbox'){ e.preventDefault(); form.submit(); }
  });
})();

})();
